import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import { ToggleButton } from 'vue-js-toggle-button';
import { TranslateResult } from 'vue-i18n';

@Component({
  name: 'bpc-switch',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    ToggleButton,
  },
})
export default class Switch extends mixins(AbstractField) {
  @Prop([String, Number, Boolean]) readonly value: string | number | boolean;
  @Prop(String) readonly checkedLabel: string;
  @Prop(String) readonly uncheckedLabel: string;
  @Prop(String) readonly checkedColor: string;
  @Prop(String) readonly uncheckedColor: string;
  @Prop({ type: Number, default: 55 }) readonly width: number;

  get model(): string | number | boolean {
    return !!this.value;
  }
  set model(val: string | number | boolean) {
    this.$emit('input', !!val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, !!val);
      });
    }
  }

  get labels(): { checked: TranslateResult | string; unchecked: TranslateResult | string } {
    return {
      checked: this.checkedLabel ? this.$t(this.checkedLabel) : this.$t('global.yes'),
      unchecked: this.uncheckedLabel ? this.$t(this.uncheckedLabel) : this.$t('global.no'),
    };
  }

  get colors(): { checked: TranslateResult | string; unchecked: TranslateResult | string } {
    return {
      checked: this.checkedColor ? this.checkedColor : '#75C791',
      unchecked: this.uncheckedColor ? this.uncheckedColor : '#BFCBD9',
    };
  }

  beforeMount() {
    this.model = !!this.value;
  }

  // onEnterKey() {
  //   this.$emit('enter-key');
  // }

  // updated () { }

  // destroyed () { }
}
